/**********************************

  worldpantry-inventory.js   (ATKINS)

  Cookie helpers + the "No Error" self-heal + live product-inventory
  functions + a POLLING auto-trigger that fires a zip lookup once the
  zipcode cookie appears.

  ZIP ACQUISITION: handled solely by assets/worldpantry-ipzipcode.js
  (the boss's app-proxy file -- key stays server-side, file is byte
  identical across all sites and is NOT modified).

  WHY POLLING: worldpantry-ipzipcode.js sets the `zipcode` cookie from
  an async fetch and dispatches no event. A one-shot read on
  $(document).ready() loses the race on a cold visit -- ready fires,
  no cookie yet, lookup never runs, and the widget only works on the
  SECOND pageview. The poller below watches for the cookie, fires
  exactly once when a VALID zip lands, and gives up at a ceiling so a
  failed/empty proxy response never spins forever.

  NOTE: worldpantry-ipzipcode.js writes an EMPTY-STRING negative cache
  (~30 min) when the proxy returns no zip. isValidZip('') is false, so
  the poller correctly keeps waiting rather than firing a junk lookup,
  and then expires out at the ceiling.

  LOAD ORDER: this file REQUIRES jQuery. In theme.liquid it must be
  loaded AFTER the jQuery script tags, not in the upper head.

  Shipping submit/display logic lives in snippets/fast-shipping-logic.liquid.

***********************************/

/* ============================================================
   CONFIG -- per-site values.
   ============================================================ */
var WP_INV = {
  endpointKey: 'WP_2025_ATKINS',
  inventoryUrlSingle: 'https://shop.worldpantry.com/productinventories/atkins/productinventory.aspx',
  inventoryUrlBatch:  'https://shop.worldpantry.com/productinventories/atkins/productinventories.aspx',

  cookies: {
    zip:       'zipcode',
    fsZip:     'FastShip.ZipCode',
    receiveBy: 'FastShip.ReceiveByDateTime',
    orderBy:   'FastShip.OrderByDateTime',
    calcError: 'FastShip.FastShipCalculationError'
  },

  // Auto-trigger hooks (the form lives in the shared snippet markup).
  zipInputSelector:  '.zip_input',
  formSelector:      'form.js-fs-form',

  // Polling ceiling for the async proxy zip.
  pollIntervalMs: 250,
  pollMaxTicks:   40,   // 40 * 250ms = 10s

  outOfStockDisplay: 'Usually ships within 1-2 weeks',
  inStockDisplay: 'In Stock'
};

/**********************************
  Cookie functions
***********************************/
function setSessionCookie(name, value) {
  document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; SameSite=Lax; Secure";
}

function getSessionCookie(name) {
  const nameKey = name + "=";
  const cArr = document.cookie.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(nameKey) === 0) res = decodeURIComponent(val.substring(nameKey.length));
  });
  return res;
}

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; Secure";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  var result = null;
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(nameEQ) === 0) result = decodeURIComponent(c.substring(nameEQ.length));
  }
  return result;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  var encodedValue = value != null ? encodeURIComponent(value) : "";
  document.cookie = name + "=" + encodedValue + expires + "; path=/; SameSite=Lax; Secure";
}

function isValidZip(str) {
  return /^\d{5}(-\d{4})?$/.test(str || "");
}

/**********************************
  One-time self-heal for a stuck error banner.
  Clears the error cookie when its value is "No Error" (success), or
  when there is no valid zip beside it (came from a blank auto-submit).
  Also clears any stale date cookie that is not parseable ISO (legacy
  "June 11" format would otherwise make the banner revert in Firefox).

  NOTE FOR ATKINS: the OLD inline header/bar scripts stored PRE-FORMATTED
  dates ("June 11") in these cookies. Returning visitors will arrive with
  those stale values; this block clears them so they re-fetch as ISO.
***********************************/
(function selfHealFastShipCookies() {
  var err = getSessionCookie(WP_INV.cookies.calcError);
  if (err) {
    var zip = getSessionCookie(WP_INV.cookies.fsZip);
    if (err === "No Error" || !isValidZip(zip)) {
      deleteCookie(WP_INV.cookies.calcError);
    }
  }
  // Legacy non-ISO date cookies -> clear so they re-fetch as ISO.
  var receiveBy = getSessionCookie(WP_INV.cookies.receiveBy);
  var orderBy = getSessionCookie(WP_INV.cookies.orderBy);
  if ((receiveBy && isNaN(new Date(receiveBy))) ||
      (orderBy && isNaN(new Date(orderBy)))) {
    deleteCookie(WP_INV.cookies.receiveBy);
    deleteCookie(WP_INV.cookies.orderBy);
  }
})();

/**********************************
  Auto-trigger (POLLING).

  worldpantry-ipzipcode.js sets the `zipcode` cookie asynchronously and
  fires no event, so we watch for it. Fires the lookup exactly once,
  the first tick a VALID zip is present, then stops. Stops regardless
  at pollMaxTicks so a cold visit with a failing proxy does not poll
  forever.

  The window.wpZipAutoTriggered guard keeps this to ONE lookup for the
  page even though the shared snippet may be rendered by several
  sections.
***********************************/
$(document).ready(function () {
  if (window.wpZipAutoTriggered) return;

  var ticks = 0;

  function fireLookup(zip) {
    window.wpZipAutoTriggered = true;
    console.log("fast geo zip " + zip);
    $(WP_INV.zipInputSelector).val(zip);
    $(WP_INV.formSelector).first().submit();
  }

  // Cookie may already be there from a previous visit -- no need to wait.
  var existing = getCookie(WP_INV.cookies.zip);
  if (isValidZip(existing)) {
    fireLookup(existing);
    return;
  }

  var poll = setInterval(function () {
    ticks++;

    var zip = getCookie(WP_INV.cookies.zip);

    if (isValidZip(zip)) {
      clearInterval(poll);
      fireLookup(zip);
      return;
    }

    if (ticks >= WP_INV.pollMaxTicks) {
      clearInterval(poll);
      console.log("no valid zipcode after polling - manual entry only");
    }
  }, WP_INV.pollIntervalMs);
});

/**********************************
  Product Inventory functions
***********************************/
const OutOfStockAlwaysSellStatusDisplay = WP_INV.outOfStockDisplay;
const InStockAlwaysSellStatusDisplay = WP_INV.inStockDisplay;

function getProductInventoryDisplay(zip, productId, variantId, setProductInventoryStatus) {
  var postproductinventory = $.post(WP_INV.inventoryUrlSingle, {
    zip: zip,
    key: WP_INV.endpointKey,
    productid: productId,
    variantid: variantId,
  });
  postproductinventory.done(function (data) {
    if (data) {
      if (data.Status == "OutOfStock") {
        data.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
      }
      setProductInventoryStatus(data);
    }
  });
}

function getProductNumbers() {
  var productNumbers;
  $.ajax({
    type: "GET",
    url: "/cart?view=wp-productnumbers",
    async: false,
  }).done(function (response) {
    productNumbers = JSON.parse(response);
  });
  return productNumbers;
}

function getProductInventories(productNumbers) {
  var items = [];
  var productInventories;
  for (var i = 0; i < productNumbers.length; i++) {
    var item = {};
    item["productId"] = productNumbers[i].productNumber;
    item["variantId"] = productNumbers[i].variantNumber;
    items.push(item);
  }

  if (items) {
    var shippingInfo = new Object();
    shippingInfo.zip = getCookie(WP_INV.cookies.zip);
    shippingInfo.items = items;
    $.ajax({
      type: "POST",
      url: WP_INV.inventoryUrlBatch,
      data: {
        key: WP_INV.endpointKey,
        shippingInfo: JSON.stringify(shippingInfo),
      },
      async: false,
    }).done(function (data) {
      productInventories = data;
    });
  }
  return productInventories;
}

/**********************************
  Async variant of getProductInventories.

  The sync version above is kept for compatibility with any other
  callers, but async:false blocks the main thread and is why the old
  inventory snippet had to run at parse time. The rewritten
  worldpantry-inventory-product.liquid uses THIS one instead.
***********************************/
function getProductInventoriesAsync(productNumbers, callback) {
  var items = [];
  for (var i = 0; i < productNumbers.length; i++) {
    items.push({
      productId: productNumbers[i].productNumber,
      variantId: productNumbers[i].variantNumber
    });
  }

  if (!items.length) {
    callback(null);
    return;
  }

  var shippingInfo = {
    zip: getCookie(WP_INV.cookies.zip),
    items: items
  };

  $.ajax({
    type: "POST",
    url: WP_INV.inventoryUrlBatch,
    data: {
      key: WP_INV.endpointKey,
      shippingInfo: JSON.stringify(shippingInfo)
    }
  })
    .done(function (data) {
      callback(data);
    })
    .fail(function () {
      console.log("inventory lookup failed");
      callback(null);
    });
}

function showProductInventoryCartStatusDisplay(productInventories) {
  var showInventoryCartStatusDisplay = false;
  if (productInventories) {
    for (var i = 0; i < productInventories.length; i++) {
      if (productInventories[i].Status == "OutOfStock") {
        showInventoryCartStatusDisplay = true;
        break;
      }
    }
  }
  return showInventoryCartStatusDisplay;
}

function getProductInventory(id, productNumbers, productInventories) {
  var inventoryStatus;
  for (var n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id == id) {
      var productNumber = productNumbers[n].productNumber;
      var variantNumber = productNumbers[n].variantNumber;
      for (var i = 0; i < productInventories.length; i++) {
        if (
          productInventories[i].ProductId &&
          productInventories[i].VariantId &&
          productInventories[i].ProductId.toUpperCase() == productNumber.toUpperCase() &&
          productInventories[i].VariantId.toUpperCase() == variantNumber.toUpperCase()
        ) {
          inventoryStatus = productInventories[i];
          if (inventoryStatus.Status == "OutOfStock") {
            inventoryStatus.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
          } else {
            inventoryStatus.StatusDisplay = InStockAlwaysSellStatusDisplay;
          }
          break;
        }
      }
      break;
    }
  }
  return inventoryStatus;
}
